<template>
	<div class="omapi-campaign-table__search-wrap">
		<span v-if="search" class="subtitle">
			{{ totalFilteredCampaignsCount }} search results for “{{ search }}”
		</span>
		<core-search-button
			class="omapi-campaign-table__search"
			:searchTerm="search"
			@searched="submitSearch"
		/>
	</div>

</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('campaigns')

export default {
	computed : {
		...mapState([ 'search', 'totalFilteredCampaignsCount' ]),
	},
	methods : {
		...mapActions([ 'goToPage' ]),
		submitSearch (search) {
			this.goToPage({ search })
		},
	},
}
</script>
